import { FC } from 'react'
import { IconPaths, KTSVG } from '../../../_metronic/helpers'
import styles from './SupportTab.module.scss'

export const SUPPORT_URL = 'https://www.lauduz.com/contato'

export const SupportTab: FC = () => (
  <a
    className={styles.abaSuporte}
    href={SUPPORT_URL}
    target='_blank'
    rel='noopener noreferrer'
    aria-label='Falar com o suporte (abre em nova aba)'
  >
    <KTSVG path={IconPaths.Suporte} className={styles.icone} svgClassName='' />
    <span className={styles.texto} aria-hidden='true'>
      Suporte
    </span>
  </a>
)
